import React from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

// Wrapper base dos modais do módulo de O.S.
// Centraliza o esqueleto repetido (Modal > Header > Body > Footer, sempre
// centered). O corpo vai em `children` e o rodapé em `footer`, ambos passados
// verbatim — assim cada modal preserva exatamente seus botões/spinners.
const ModalFormOS = ({ isOpen, toggle, title, size, children, footer }) => (
  <Modal isOpen={isOpen} toggle={toggle} size={size} centered>
    <ModalHeader toggle={toggle}>{title}</ModalHeader>
    <ModalBody>{children}</ModalBody>
    <ModalFooter>{footer}</ModalFooter>
  </Modal>
)

export default ModalFormOS
